(function() {
  function initNavOverlay() {
    const overlay = document.querySelector('.bg-nav-overlay');
    const header = document.getElementById('x-header-container');
    if (!overlay || !header) return;
    
    const updateTop = () => {
      overlay.style.top = Math.max(0, header.getBoundingClientRect().top) + 'px';
    };
    
    updateTop();
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('resize', updateTop);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavOverlay);
  } else {
    initNavOverlay();
  }
  
  document.addEventListener('alpine:init', initNavOverlay);
})();

